import styled from "styled-components";

export const FestivalInterviewContentWrapper = styled.div`
  box-shadow: 0px 4px 4px 0px #00000040;
  width: calc(100% - 32px);
  margin: 26px auto 0;
  border-radius: 8px;
  padding: 20px 12px 30px;

  > .title {
    font-weight: 700;
    font-size: 20px;
    color: #121212;
    border-bottom: 1px solid #dedede;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }
`;

export const FestivalInterviewContentInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .date {
    color: #808080;
    font-weight: 500;
    font-size: 14px;
  }

  > .nickname {
    font-weight: 700;
    font-size: 14px;
    color: #121212;
  }
`;

export const FestivalInterviewContentText = styled.div`
  margin-top: 12px;

  > .content {
    & img {
      width: 100%;
    }
    > p {
      margin: 0;
      letter-spacing: 0.3px;
      line-height: 24px;
      > strong {
        > a {
          color: #379339;
          text-decoration: underline;
        }
      }
    }
  }
`;
